import { getBreakPoints, getDiffInArrays } from '../../helpers';
import type { InViewObserverCallback } from '../types';
import type { IProducts } from '../../../../types/product/productDetailPage';

/**
 * Moved it from FeaturedProductList
 * what does it do: This publishes event payloads to data layer
 * Trigger: inView
 */
export const inViewObserverCallback = ({
  inView, entry, refCount, impressionHandler, maxItems,
}: InViewObserverCallback) => {
  if (inView && entry.isIntersecting) {
    const dataAttribute = JSON.parse(entry.target.attributes.getNamedItem('data-product')?.value || 'A') as IProducts;

    // it is interpreted by eslint as function argument reassignment but it is actually a valid ref.current update
    /* eslint-disable*/
    refCount.current.viewedProducts = [...refCount.current.viewedProducts, dataAttribute];

    const movingSumOfProductCountInView = refCount.current.viewedProducts;
    const inViewPortScreenWidth = entry!.rootBounds!.width;
    const eventsDispatchedForProducts = refCount.current.eventsDispatchedForProducts;
    if (movingSumOfProductCountInView.length === maxItems && inViewPortScreenWidth >= getBreakPoints('md')) {
      if (impressionHandler) {
        impressionHandler({ products: refCount.current.viewedProducts });
      }
    }

    if (movingSumOfProductCountInView.length % 2 === 0 && inViewPortScreenWidth < getBreakPoints('md')) {
      const productsToFireEventsFor = getDiffInArrays(
        eventsDispatchedForProducts,
        movingSumOfProductCountInView,
      );

      if (impressionHandler) {
        impressionHandler({ products: productsToFireEventsFor });
      }

      //it is interpreted by eslint as function argument reassignment but it is actually a valid ref.current update
      /* eslint-disable */
      refCount.current.eventsDispatchedForProducts = [...refCount.current.viewedProducts];
    }
  }
};
